import { render } from "./TrialBindCard.vue?vue&type=template&id=2b8b6f3a&scoped=true"
import script from "./TrialBindCard.vue?vue&type=script&lang=js"
export * from "./TrialBindCard.vue?vue&type=script&lang=js"

import "./TrialBindCard.vue?vue&type=style&index=0&id=2b8b6f3a&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8b6f3a"]])

export default __exports__